import { DamageStepText } from "./types";

export const DAMAGE_INFO_STEP = 0;
export const DAMAGE_DOCUMENTS_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. Srednji korak (fotografije) nema intro. */
export const DAMAGE_INTRO_TEXTS: Record<number, DamageStepText> = {
  [DAMAGE_INFO_STEP]: {
    title: "Prijavite štetu na vozilu",
    description: "Upišite što se dogodilo i kada. Šteta se odmah bilježi u povijesti vozila.",
  },
  [DAMAGE_DOCUMENTS_STEP]: {
    title: "Priložite dokumentaciju",
    description: "Zapisnik, europsko izvješće ili ponuda servisa. Sve ostaje uz štetu na jednom mjestu.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const DAMAGE_INTRO_SAMPLE = {
  name: "Ogrebotina na stražnjim vratima",
  description: "Oštećenje nastalo pri parkiranju, lak ogreben do temeljne boje.",
  image: "/media/images/vehicles/vehicle-2.png",
  documents: ["Zapisnik o šteti.pdf", "Europsko izvješće.pdf", "Ponuda servisa.pdf"],
};

/** Mjesta oznaka štete na slici vozila (postotak širine i visine slike). */
export const DAMAGE_INTRO_PINS = [
  { left: "28%", top: "52%" },
  { left: "63%", top: "44%" },
];
